module.exports = __webpack_public_path__ + "static/banner-furnisima-source-code-ebd204590ae46bea415d856ab38c7262.png";